import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toast } from 'react-toastify';

import axios from '../../../../axios-instance';

import styles from './DudaIntegrationPage.module.sass';
import { getHeaders } from '../../../../helpers/getHeaders';
import NewLoader from '../../../../components/NewLoader/NewLoader';
import { StatusLabel } from '../../../../components/Transactions/StatusLabel/StatusLabel';
import { generalStatuses, GeneralStatusLabel } from "../../../../components/Transactions/StatusLabel/GeneralStatusLabel";
import Icon from '../../../../components/UI/Icon/Icon';

export const DudaIntegrationPage = ({ token }) => {
  const [isDataLoading, setDataLoading] = useState(true);
  const [hasDudaIntegration, setHasDudaIntegration] = useState(false);

  const loadData = async () => {
    setDataLoading(true);

    try {
      const { data } = await axios.get('DudaIntegration/Status', {
        headers: getHeaders(token),
      });

      setHasDudaIntegration(data);
    } finally {
      setDataLoading(false);
    }
  }

  const goToStorePage = async () => {

    try {
      const { data } = await axios.get('DudaIntegration/GetSSOLink', {
        headers: getHeaders(token),
      });

      window.open(data, '_blank');
    }
    catch {

    }
  }

  useEffect(() => {
    loadData();
  }, []);

  if (isDataLoading) {
    return <NewLoader />;
  }

  return (
    <section className={styles['duda-integration-page']}>

      {hasDudaIntegration &&
        <>
          <GeneralStatusLabel status={generalStatuses.active}>
            <Icon name='approve' color={generalStatuses.active.iconColor} />  Duda connected
          </GeneralStatusLabel>

          <button className={`btn-primary-new admin ${styles['go-to-store-page-button']}`}
            onClick={goToStorePage}>
            Go to store page
          </button>
        </>
      }

      {!hasDudaIntegration &&
        <>
          <GeneralStatusLabel status={generalStatuses.error}>
          <Icon name='cancel' color={generalStatuses.error.iconColor} />  Duda not connected
          </GeneralStatusLabel>
        </>
      }
    </section>
  )
}

const mapStateToProps = ({ auth }) => ({
  token: auth.user.token,
});

const mapDispatchToProps = (dispatch) => ({

});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DudaIntegrationPage)
);
